export default __webpack_public_path__ + "static/media/wincarousel-phone3.3aa23020.png";